import Hero from './sections/HomeHero';
import HomeContact from './sections/HomeContact';
import HomeCourses from './sections/HomeCourses';
import HomeFooter from './HomeFooter';
import HomeLessons from './sections/HomeLessons';
import HomePricing from './sections/HomePricing';
import { Box, Flex } from '@chakra-ui/react';
import { formatDocumentTitle } from '../../utils/documentTitle';
import { HomeAbout } from './sections/HomeAbout';
import { HomeBanner } from './sections/HomeBanner';
import { HomeFaq } from './sections/HomeFaq';
import { HomeLocations } from './sections/HomeLocations';
import { HomeStats } from './sections/HomeStats';
import { HomeTestimonials } from './sections/HomeTestimonials';

export function HomePage() {
	document.title = formatDocumentTitle('Opanuj.to');
	return (
		<Flex direction='column' h="100%" w="100vw">
			<Box
				id="home-page"
				flexGrow='1'
				overflow="scroll"
			>
				<HomeBanner />
				<Hero />
				<HomeAbout />
				<HomeStats />
				<HomeLessons />
				<HomeCourses />
				<HomePricing />
				<HomeFaq />
				<HomeTestimonials />
				<HomeLocations/>
				<HomeContact />
				<HomeFooter />
			</Box>
		</Flex>
	);
}
